// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import FormActions from "@store/Library/Components/Toolkit/FormActions";
import constants from "@store/constants";
import clearSearch from "@store/Framework/Store/Greif/Pages/TrailerTracking/Handlers/ClearSearch";
import updateSearchFields from "@store/Framework/Store/Greif/Pages/TrailerTracking/Handlers/UpdateSearchFields";
import { historyFilterProps } from "@store/Themes/common/props/history";
import * as React from "react";
import { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: ApplicationState) => ({
    currentShipTo: getCurrentShipToState(state),
});

const mapDispatchToProps = {
    clearSearch,
    updateSearchFields,
};

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

export interface TrailerTrackingSearchClearButtonStyles {
    clearButton?: ButtonPresentationProps;
}

export const clearButtonStyles: TrailerTrackingSearchClearButtonStyles = {
    clearButton: historyFilterProps.clearButton,
};

const styles = clearButtonStyles;

const TrailerTrackingSearchClearButton = ({ currentShipTo, clearSearch, updateSearchFields }: Props) => {
    const [currentCustomerSequence, setCurrentCustomerSequence] = useState<string>("");

    useEffect(() => {
        if (currentShipTo.value && !currentShipTo.isLoading) {
            setCurrentCustomerSequence(currentShipTo.value.customerSequence);
        }
    }, [currentShipTo]);

    const clearSearchHandler = () => {
        clearSearch();
        updateSearchFields({ shipToBp: currentCustomerSequence });
    };

    return (
        <FormActions>
            <Button
                {...styles.clearButton}
                data-test-selector="trailerTracking_clearFilters"
                onClick={clearSearchHandler}
            >
                {translate("Clear Filters")}
            </Button>
        </FormActions>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(TrailerTrackingSearchClearButton),
    definition: {
        group: constants.widgetGroup.trailerTracking,
        displayName: "Clear Filters Button",
        allowedContexts: [constants.pageType.trailerTracking],
    },
};

export default widgetModule;
